// Комментарий на русском: iOS показывает над клавиатурой панель Prev/Next/Done,
// если на странице есть несколько фокусируемых полей ввода.
// Полностью отключить эту панель в Safari/PWA нельзя, но можно убрать Prev/Next,
// временно оставив фокусируемым только одно поле (остальные делаем disabled).

type FormEl = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

export function isIOSDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  // Комментарий на русском: iPadOS может маскироваться под Mac, но с touch.
  return /iP(ad|hone|od)/.test(ua) || (ua.includes('Mac') && typeof document !== 'undefined' && 'ontouchend' in document);
}

export function enterIosSingleInputMode(activeEl: FormEl, root?: ParentNode): () => void {
  if (!isIOSDevice()) return () => {};
  const r: ParentNode = root || document;

  const touched: Array<{ el: FormEl; disabled: boolean }> = [];
  try {
    const all = Array.from(r.querySelectorAll('input, textarea, select')) as FormEl[];
    for (const el of all) {
      if (!el || el === activeEl) continue;
      // Комментарий на русском: hidden не участвует в навигации — не трогаем.
      const t = (el as HTMLInputElement).type;
      if (typeof t === 'string' && t.toLowerCase() === 'hidden') continue;
      if (el.disabled) continue;
      touched.push({ el, disabled: false });
      el.disabled = true;
    }
  } catch {
    // ignore
  }

  return () => {
    try {
      for (const it of touched) it.el.disabled = it.disabled;
    } catch {
      // ignore
    }
  };
}


